const sources = [
  {
    id: "archive",
    icon: "ri-archive-drawer-line",
    title: "公开平台存档",
    desc: "来自公开社交平台的可回溯画面，保留原始发布时间，便于按事件名检索比对。",
    tag: "可回溯",
    style: "bg-accent-100 text-accent-900",
  },
  {
    id: "submit",
    icon: "ri-mail-send-line",
    title: "匿名投稿整理",
    desc: "读者投稿后统一编号归档，来源栏保留投稿渠道，未提供原图时统一标注为待核。",
    tag: "需交叉核对",
    style: "bg-primary-100 text-primary-700",
  },
  {
    id: "watermark",
    icon: "ri-camera-lens-line",
    title: "设备水印留存",
    desc: "画面自带系统时钟、镜头水印或地理标记，属于可信度较高的一类，仍建议多处印证。",
    tag: "可信度较高",
    style: "bg-secondary-100 text-secondary-900",
  },
];

export default function SourceNote() {
  return (
    <section id="source" className="w-full py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="font-label text-xs uppercase tracking-[0.22em] text-primary-600">
              Source labeling
            </span>
            <h3 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              每张图，都标清来源
            </h3>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
              来源标注是判断黑料照片是否可作为佐证的第一步。我们把
              <strong className="mx-1 font-semibold text-foreground-900">实锤证据</strong>
              按来源分成三类，并在卡片上单独列出来源、时间戳与定位三栏，方便你逐项核对。
            </p>
            <div className="mt-6 flex items-center gap-3 rounded-lg border border-accent-200 bg-accent-50 px-4 py-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-accent-950">
                <i className="ri-error-warning-line text-lg" />
              </span>
              <p className="text-xs leading-6 text-accent-900">
                画面内容仅供对照参考，请以来源原图为准，避免仅凭单张截图下结论。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-8 lg:grid-cols-3">
            {sources.map((source) => (
              <article
                key={source.id}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-background-100 text-foreground-800">
                  <i className={`${source.icon} text-xl`} />
                </span>
                <h4 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {source.title}
                </h4>
                <p className="mt-2 flex-1 text-xs leading-6 text-foreground-600">{source.desc}</p>
                <span
                  className={`mt-4 inline-flex w-fit whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] ${source.style}`}
                >
                  {source.tag}
                </span>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}